import Vue from 'vue';
import { getMemberCountList, getActivityList, getMemberData, getOrderProducts, updateOrderProducts } from '../../../services/personnelService/orderOnlineService';

// initial state
// state 必為模組區域變數，取時需 store.state.auth.user
// 其他則視 default 內是否有設 namespaced = true 來決定是全域還是區域
// 區域使用時值需加上 name
const state = {
  member:{
    picture_url:""
  },
  memberList: [],
  activityList:[],
  pagination: {
    current_page: 0,
    per_page: 15
  },
  product:{
    eventName:"",
    products:[]
  },
};

// getters
const getters = {};

// actions
const actions = {
  // 取得預約清單
  async getMemberListHandler({ commit }, paginationInfo) {
    const data = await getMemberCountList(paginationInfo);
    commit('setMemberList', data);
  },
  async getActivityHandler({ commit }) {
    const data = await getActivityList();
    commit('setActivityList', data);
  },
  async getDataHandler({ commit }, userId) {
    const data = await getMemberData(userId);
    commit('setMemberData', data);
  },
  //取得product庫存
  async getProductHandler({ commit }, input) {
    const data = await getOrderProducts(input);
    commit('setProduct', data);
  },
  // 修改庫存
  async updateProductHandler({}, updateInfo) {
    await updateOrderProducts(updateInfo);
  },
};

// mutations
const mutations = {
  setMemberList(state, data) {
    Vue.set(state, 'memberList', state.memberList.concat(data.data.member));
    Vue.set(state, 'pagination', data.data.pagination);
  },
  setActivityList(state, data) {
    Vue.set(state, 'activityList', data.data);
  },
  setMemberData(state, data) {
    Vue.set(state, 'member', data.data);
  },
  setProduct(state, data) {
    Vue.set(state, 'product', data.data);
  },
  //重置分頁
  resetHandler(state) {
    Vue.set(state, 'memberList', []);
    Vue.set(state, 'pagination', {
      current_page: 0,
      per_page: 15
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
